'use client'

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import { User } from '@/lib/types'
import { SearchIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { ChatKitPageWrapper } from '../_components/chatkit-page-wrapper'
import { ChatKitLoginGate } from '../_components/chatkit-login-gate'
import { getChatKitConstants } from './_const'

interface IMarketResearchClientProps {
  user: User | null
  userApiKey: string
  hasApiKey: boolean
}

/**
 * Client component for Market Research Agent
 * Handles ChatKit integration and user interactions
 */
export default function MarketResearchClient({
  user,
  userApiKey,
  hasApiKey,
}: IMarketResearchClientProps) {
  const t = useTranslations('market-research')
  const constants = getChatKitConstants(t)

  if (!user) {
    return (
      <ChatKitLoginGate
        icon={SearchIcon}
        title="Log in to run market research with AI"
        description="See how the Market Research Agent structures competitive insights. Sign in to save reports, attach files, and export slides."
        redirectUrl="/chatkit/market-research"
      />
    )
  }

  if (!hasApiKey) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <SearchIcon />
          </EmptyMedia>
          <EmptyTitle>No API Key</EmptyTitle>
          <EmptyDescription>
            Create an API key from your workspace settings to use the Market
            Research Agent.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    )
  }

  return (
    <ChatKitPageWrapper
      user={user}
      userApiKey={userApiKey}
      workflowKey="market_research"
      constants={constants}
      t={t}
      icon={SearchIcon}
    />
  )
}
